import { render, staticRenderFns } from "./SyncStocks.vue?vue&type=template&id=45ac32a3"
import script from "./SyncStocks.vue?vue&type=script&lang=js"
export * from "./SyncStocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports